import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=4a8e4eca&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e4eca",
  null
  
)

export default component.exports